import { IFileSetting } from '../../types/File/FileSetting';
import { IFile } from '../../types/File/IFile';
import { Api } from './BaseApi'

const FileApi = Api.injectEndpoints({
    endpoints: (build) => ({
        isActive: build.query<boolean, number>({
            query: (typeId) => `File/IsActive/${typeId}`,
            providesTags: ["FileIsActive"],
        }),
        getFiles: build.query<IFile[], { typeId: number, primaryId: number }>({
            query: ({ typeId, primaryId }) => `File/${typeId}/${primaryId | 0}`,
            providesTags: ["GetFiles"],
        }),
        getTicketFiles: build.query<IFile[], { ticketId: number }>({
            query: ({ ticketId }) => `Ticket/${ticketId}/File`,
            providesTags: ["GetTicketFiles"],
        }),
        getFileSettings: build.query<IFileSetting, void>({
            query: () => `File/Settings`,
            providesTags: ["GetFileSetting"],
        }),
        deleteFile: build.mutation<boolean, string>({
            query: (id) => ({
                url: `File/${id}`,
                method: "DELETE"
            }),
            invalidatesTags: ["GetFiles", "GetTicketFiles", "GetActions"]
        }),
        refetchFiles: build.mutation<null, void>({
            queryFn: () => ({ data: null }),
            invalidatesTags: ['GetFiles'],
        }),
    }),
    overrideExisting: false,
})

export { FileApi };